import { getAnalyticsClient, getClientProperties } from './helpers';

async function getClient(id) {
  let client = await getAnalyticsClient('_kmq', '//i.kissmetrics.com/i.js');
  if (!client) {
    client = await getAnalyticsClient('_kmq', `//scripts.kissmetrics.com/${id}.2.js`);
  }
  return client;
}

/**
 * The Kissmetrics analytics client factory function that sets up the `trackEvent`,
 * `trackConverion` and/or `trackUser` methods orchestrated by the upstream
 * analytics provider.
 *
 * @kind function
 * @name kissmetrics
 * @sig {k: v} -> (* -> undefined) -> Boolean -> {k: v}
 * @param {Object} config The analytics config that contains the required kissmetrics `id` (which is provided to Carvana for our paid enterprise account)
 * @param {Function} log An optional logging method that unless it is undefined will always collect the event name and data.
 * @param {Boolean} noPublish Whether or not to send the event to the remote analytics service (or the global script attached to the same app).  This is mainly for debugging, never for production.
 * @returns {Object} An object containing the `trackEvent` and/or `trackConversion` implementations
 */
function kissmetrics(config = {}, log, noPublish) {
  return {
    async trackEvent(eventName, eventData = {}) {
      if (config.id) {
        const trackEventKissmetrics = await getClient(config.id);

        if (trackEventKissmetrics) {
          const { metadata } = config;
          const mergedData = { ...getClientProperties(), ...eventData, ...metadata };

          if (log) {
            log('[Analytics_KissMetrics_Event]', {
              data: ['record', eventName, mergedData]
            });
          }

          if (!noPublish) {
            trackEventKissmetrics.push(['record', eventName, mergedData]);
          }
        }
      }
    },

    async trackUser(userId) {
      if (config.id) {
        const trackEventKissmetrics = await getClient(config.id);

        if (trackEventKissmetrics) {
          if (log) {
            log('[Analytics_KissMetrics_UserIdentification]', { data: ['identify', userId] });
          }

          if (!noPublish) {
            trackEventKissmetrics.push(['identify', userId]);
          }
        }
      }
    }
  };
}

export default kissmetrics;
